import React, { useEffect } from "react";
import "./SelfieErrorComponent.css";
import { selfieErrorCameraImage } from "../../../images/btnIcons";
import LanguageTranslater from "../../HOC/LanguageTranslater";
import lottie from "lottie-web";
import errorAnimationJson from "../../../images/new_ui_imgs/error.json";

const SelfieErrorComponent = ({
  selfieSubmitErrMessage,
  retake,
  translate,
}) => {
  // debugger;
  const ln = localStorage.getItem("LanguageSelected");

  useEffect(() => {
    const instance = lottie.loadAnimation({
      container: document.querySelector("#selfieError-journey-animation-div"),
      animationData: errorAnimationJson,
      // loop: false
    });

    return () => {
      instance.destroy();
    };
  }, []);

  console.log("selfieSubmitErrMessage", selfieSubmitErrMessage);
  return (
    <div className="selfieError_journey-container-center">
      <div className="selfieError_journey-content-center">
        <div className="selfieError_journey-image">
          <div className="selfieError_journey-image-container">
            <img src={selfieErrorCameraImage} alt="SelfieErrorImage" />
            <div id="selfieError-journey-animation-div" />
          </div>
        </div>

        <div className="selfieError_journey-head-txt">
          <p className={ln == "Manipuri" ? "manipuri-font" : ""}>
            {translate(selfieSubmitErrMessage)}
          </p>
        </div>

        <div className="selfieError_journey-para-txt">
          <p className={ln == "Manipuri" ? "manipuri-font" : ""}>
            {translate("Please retake the photo")}
          </p>
        </div>
      </div>
      <div className="selfieError_journey-button-center">
        <button
          className={ln == "Manipuri" ? "manipuri-font" : ""}
          onClick={(e) => retake(e)}
        >
          {translate("Retake Photo")}
        </button>
      </div>
    </div>
  );
};

export default LanguageTranslater(SelfieErrorComponent);
